import React, { Fragment, useEffect } from "react";
import { MONGOURL } from "@data/GlobalData.js";
import { useGenericStore } from "@customHooks/useGenericStore.js";
import { PROCESS_ADD, PROCESS_DELETE } from "@genericComponents/CFW.js";
import { Clone } from "@genericComponents/Common.js";
import { PostData } from "@genericComponents/SFW.js";
import { GetState, RemoveState } from "@genericComponents/StoreToolkit.js";
const GenerateStateEntry =
  await import("@asyncImports/GenerateStateEntry.js").then(
    (mod) => mod.GenerateStateEntry,
  );
const MatchingFieldsOnly =
  await import("@asyncImports/MatchingFieldsOnly.js").then(
    (mod) => mod.MatchingFieldsOnly,
  );
const FileProcessor = () => {
  const CFW_UPLOAD_GROUP_ID = "UPLOAD_GROUP_ID";
  const fileAttachment = useGenericStore(CFW_UPLOAD_GROUP_ID);
  const ClearWindowParams = () => {
    RemoveState(CFW_UPLOAD_GROUP_ID);
    if (window?.processing) {
      delete window.processing;
    }
    if (window?.uploadEvent) {
      delete window.uploadEvent;
    }
  };
  const BeginProcess = () => {
    const fileData = GenerateStateEntry(
      fileAttachment.Response,
      fileAttachment.Param,
      `${fileAttachment.ColumnGroup}-${
        fileAttachment.Process === PROCESS_ADD ? "" : fileAttachment.Id
      }`,
    );
    const DeleteFiles = () => {
      const param = Clone(fileData.entry.param);
      param.Process = PROCESS_DELETE;
      param.Filter[fileAttachment.ColumnGroup] = fileAttachment.Id;
      PostData(
        [MONGOURL, fileAttachment.Service].join(""),
        param,
        fileAttachment.Response,
        () => {
          RemoveState(fileData.list.state);
          ClearWindowParams();
        },
      );
    };

    useEffect(() => {
      if (!window.processing) {
        window.processing = true;
        if (fileAttachment.Process === PROCESS_DELETE) {
          DeleteFiles();
        } else {
          const attachmentData = GetState(fileData.list.state, []);
          const filesToProcess = attachmentData?.length
            ? [...attachmentData].filter(
                (item) =>
                  item?.Process &&
                  !(
                    item?.Process === PROCESS_DELETE &&
                    item?._id.substring(0, 1) === "_"
                  ),
              )
            : [];
          if (!filesToProcess?.length) {
            ClearWindowParams();
          } else {
            const results = filesToProcess.map(async (currentFile) => {
              return new Promise((resolve) => {
                const param = MatchingFieldsOnly(
                  currentFile,
                  fileData.entry.param,
                );
                param.Filter = MatchingFieldsOnly(currentFile, param.Filter);
                param.Filter[fileAttachment.ColumnGroup] = fileAttachment.Id;
                delete param.Filter.AttachmentName;
                delete param.Filter._id;
                if (currentFile.UrlPathOrFileName?.fileName) {
                  param.Filter.UrlPathOrFileName =
                    currentFile.UrlPathOrFileName.fileName;
                  param.UrlPathOrFileName =
                    currentFile.UrlPathOrFileName.fileName;
                }
                param[fileAttachment.ColumnGroup] = fileAttachment.Id;
                PostData(
                  [MONGOURL, fileAttachment.Service].join(""),
                  param,
                  fileAttachment.Response,
                  () => {
                    if (
                      currentFile.UrlPathOrFileName.blob &&
                      fileAttachment.Folder &&
                      currentFile.UrlPathOrFileName.fileName &&
                      window?.uploadEvent
                    ) {
                      window.uploadEvent(
                        currentFile.UrlPathOrFileName.blob,
                        fileAttachment.Folder,
                        currentFile.UrlPathOrFileName.fileName,
                        () => {
                          resolve(true);
                        },
                      );
                    } else {
                      resolve(true);
                    }
                  },
                );
              });
            });
            Promise.all(results).then(() => {
              ClearWindowParams();
            });
          }
        }
      }
      return () => {};
    }, [fileAttachment]);
    return <Fragment />;
  };
  return fileAttachment ? <BeginProcess /> : <Fragment />;
};
export default FileProcessor;
